export default __webpack_public_path__ + "static/media/Company&Products.cb0bcf71.pdf";